import ToolCard from './ToolCard.jsx';

const SelectedTools = ({ t, installedTools, onToggleTool, onSettings, onDelete }) => (
  <div className="flex w-full flex-col gap-3">
    {installedTools.map((tool) => (
      <ToolCard
        key={tool.id}
        t={t}
        title={tool.title}
        description={tool.description}
        isEnabled={tool.isEnabled}
        onToggle={() => onToggleTool(tool.id)}
        onSettings={() => onSettings(tool)}
        onDelete={() => onDelete(tool.id)}
        toolData={tool}
        requiresSetup={tool.requiresConfiguration === true || tool.tag === 'Requires configuration'}
      />
    ))}
  </div>
);

export default SelectedTools;
